"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.findEditionIdFromHostname = void 0;
const config_client_1 = __importDefault(require("./config/editions/config.client"));
const hostnameToEditionMap = Object.entries(config_client_1.default.byEdition)
    .reduce((accum, [key, config]) => {
    const hostnames = [
        config.hostname,
        ...(Array.isArray(config.additional_hostnames)
            ? config.additional_hostnames
            : []),
    ];
    const hostnamesByKey = hostnames.map(v => [
        key,
        v,
    ]);
    return accum.concat(hostnamesByKey);
}, [])
    .sort(([a], [b]) => b.split('').reverse().join().localeCompare(a.split('').reverse().join()));
function findEditionIdFromHostname(searchHostname) {
    const [id = null] = hostnameToEditionMap.find(([, hostname]) => searchHostname.endsWith(hostname)) || [];
    return id;
}
exports.findEditionIdFromHostname = findEditionIdFromHostname;
//# sourceMappingURL=find-edition-id-from-hostname.client.js.map